import "react-dates/initialize";

import Sidebar from "components/Sidebar/SidebarWhite";
import CartPopUp from "containers/Cart/CartPopUp";
import Products from "containers/Products/Products";
import { listCategorys } from "containers/Sidebar/Sidebar";
import { AuthContext } from "contexts/auth/auth.provider";
import { SearchContext } from "contexts/search/search.provider";
import { useFormik } from "formik";
import gql from "graphql-tag";
import { listProductsByCategory } from "graphql/query/product.query";
import { initializeApollo } from "helper/apollo";
import Head from "next/head";
import React, { useContext } from "react";
import styled from "styled-components";
import * as Yup from "yup";

const BannerContainer = styled.div`
  height: 250px;
  background: url(${(props) => props.imageUrl}) no-repeat;
  background-position: center;
  background-size: cover;
`;

function HomePage({ slug, category }) {
  const { deviceType } = useContext(AuthContext);
  const { search, setSearch } = useContext(SearchContext);

  const { getFieldProps, handleSubmit, values, setFieldValue, isValid } =
    useFormik({
      enableReinitialize: true,
      initialValues: search || {},
      onSubmit: (values) => {
        setSearch(values);
      },
      validationSchema: Yup.object().shape({
        text: Yup.string().required("required"),
      }),
    });
    
  return (
    <>
      <Head>
        <title>Experience more. Own less. - Scuttle</title>
        <meta property="fb:app_id" content={"343472203701213"} />
        <meta property="og:url" content={process.env.BASE_URL} />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content={`Experience more. Own less. - Scuttle`}
        />
        <meta
          property="og:description"
          content="Rent top quality products. Delivered to your door."
        />
        <meta
          property="og:image"
          content={`${process.env.BASE_URL}/og_home.png`}
        />
      </Head>

      <div className="bg-gray-100 min-h-screen ">
        <div className="max-w-screen-xl mx-auto md:pt-8">
          <div className="md:flex-1 md:flex md:overflow-y-hidden">
            <Sidebar />
            <div className="pt-24 md:pt-0 md:flex-1 px-2 pt-4 sm:px-8  ">
              {/* Rest of your component code */}

              {/* <BannerContainer imageUrl={category?.imageUrl}
                                             className="hidden md:block bg-indigo-700 rounded-lg p-4 md:flex md:flex-col md:items-start md:justify-end"> */}
              <div className="px-2 pt-2 flex flex-col sm:flex-row items-start sm:items-center justify-between">
                <h1 className="text-3xl font-bold tracking-tight text-scuttle-blue mb-4 sm:mb-0">
                  {category?.name === "Bicycle Transport" ? 'Travel' : category?.name || "Rentals"}
                </h1>
                {/* <div className="w-full sm:w-auto lg:w-1/2">
                  <form className="sm:flex" onSubmit={handleSubmit}>
                    <input
                      {...getFieldProps("text")}
                      onChange={(e) => {
                        setFieldValue("text", e.target.value);
                        if (!e.target.value) {
                          setSearch({ text: null });
                        }
                      }}
                      type="search"
                      className="appearance-none w-full px-5 py-3 border border-transparent text-base leading-6 rounded-md text-gray-900 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 transition duration-150 ease-in-out"
                      placeholder="Search for a product, brand or category..."
                    />
                    <div className="mt-3 rounded-md shadow sm:mt-0 sm:ml-3 sm:flex-shrink-0">
                      <button className="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-scuttle-orange">
                        Search
                      </button>
                    </div>
                  </form>
                </div> */}
              </div>

              <div className="mt-0 sm:mt-8 mx-auto max-w-full">
                <Products category={slug} deviceType={deviceType} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <CartPopUp />
    </>
  );
}

export const getServerSideProps = async (nextContext) => {
  const apolloClient = initializeApollo();
  const { query } = nextContext;

  const [
    {
      data: {
        listCategorys: { items: categories },
      },
    },
  ] = await Promise.all([
    apolloClient.query({
      query: gql(listCategorys),
      variables: {
        company: "scuttle",
        limit: 100,
      },
    }),
    apolloClient.query({
      skip: !query.category,
      query: gql(listProductsByCategory),
      variables: {
        company: "scuttle",
        categoryIdSeq: {
          beginsWith: {
            categoryId: `${query.category}#`,
          },
        },
        limit: 24,
        nextToken: null,
      },
    }),
  ]);

  const props = JSON.parse(
    JSON.stringify({
      category: categories.find((c) => c.id === query.category),
      slug: query.category,
      initialApolloState: apolloClient.cache.extract(),
    })
  );

  return {
    props,
  };
};

export default HomePage;
